__turbopack_context__.v({
  "fullBleed": "RecoveryImageCarousel-module__aMx1_W__fullBleed",
  "slideFrame": "RecoveryImageCarousel-module__aMx1_W__slideFrame",
  "slideImage": "RecoveryImageCarousel-module__aMx1_W__slideImage",
  "slideMedia": "RecoveryImageCarousel-module__aMx1_W__slideMedia",
});
